import { IAsset, IAssetDetails } from '@move-frontend/contentful';
import { IHighlightSectionEntry } from '../../../../contentful';
import Highlight from '../../../../components/common/highlight/Highlight';
import { getUrlForLink } from '../../../../utils/getUrlForLink';
import { useCommonData } from '../../../../common-data/useCommonData';
import {
	IImagePosition,
	IResponsiveImageSource,
	Markdown,
	getResponsiveContentfulImageUrl,
} from '../../../../ui';

interface IHighlightSectionProps {
	id: string;
	section: IHighlightSectionEntry;
}

export default function HighlightSection({
	id,
	section,
}: IHighlightSectionProps) {
	const { pathToPageIdMap } = useCommonData();

	return (
		<Highlight
			id={id}
			title={section.fields.title}
			subtitle={section.fields.subtitle}
			imageAlt={section.fields.title}
			imageSource={getHighlightImageSource(section.fields.image)}
			imagePosition={
				section.fields.imagePosition === ('right' as IImagePosition)
					? ['last', { mobileXL: 'first' }]
					: ['first', { mobileXL: 'first' }]
			}
			orientation={['horizontal', { mobileXL: 'vertical' }]}
			linkHref={getUrlForLink(section.fields.link, pathToPageIdMap)}
			linkTitle={section.fields.link && section.fields.link.fields.title}
			linkType={section.fields.link?.contentType}
			body={<Markdown source={section.fields.body as string} />}
		/>
	);
}

function getHighlightImageSource(
	image: IAsset<IAssetDetails, string> | undefined,
): IResponsiveImageSource {
	if (!image) {
		return '';
	}

	const { url } = image.fields.file;

	return [
		getResponsiveContentfulImageUrl(url, { w: 1200, h: 900, fit: 'thumb' }),
		{
			mobileXL: getResponsiveContentfulImageUrl(url, {
				w: 720,
				h: 480,
				fit: 'thumb',
			}),
		},
	];
}
